module.exports = __webpack_public_path__ + "static/media/acerta-phone.9b19e205.svg";